export default __webpack_public_path__ + "static/media/phone.46160c7e.png";